import classNames from 'classnames';
import Avatar from 'components/Avatar';
import React from 'react';
import styles from './DynamicUserAvatar.module.scss';

interface Props {
  user: { id: number; name: string; avatar?: string | null };
  avatar?: string;
  renderNotificationStyles: { color: string; icon: JSX.Element | null };
  hasNotification: boolean;
  size: 'small' | 'medium' | 'default';
  className?: string;
  tooltip?: boolean;
}

const sizes = {
  default: {
    width: 34,
    height: 34,
    border: 3,
    iconScale: 0.6,
  },
  medium: {
    width: 22,
    height: 22,
    border: 2,
    iconScale: 0.6,
  },
  small: {
    width: 16,
    height: 16,
    border: 2,
    iconScale: 0.7,
  },
};

const DynamicUserAvatar: React.FC<Props> = ({
  renderNotificationStyles,
  user,
  hasNotification,
  tooltip,
  ...props
}) => {
  const avatarUrl = props.avatar ? props.avatar : user.avatar;
  const size = sizes[props.size];
  return (
    <div className={classNames(styles.container, props.className)}>
      <Avatar
        src={avatarUrl}
        className={classNames(styles.avatar, { [styles.basicBorder]: hasNotification })}
        style={{
          borderWidth: size.border,
          borderRadius: '50%',
          boxShadow: hasNotification
            ? `0 0 0 ${size.border}px ${renderNotificationStyles.color}`
            : 'initial',
        }}
        shape="circle"
        name={user.name}
        tooltipPosition="left"
        tooltip={user.name === 'Timely'}
        {...size}
      />
      {hasNotification && (
        <div
          style={{ height: size.height * size.iconScale, width: size.width * size.iconScale }}
          className={styles.icon}
        >
          {renderNotificationStyles.icon}
        </div>
      )}
    </div>
  );
};

DynamicUserAvatar.defaultProps = {
  size: 'default',
};

export default DynamicUserAvatar;
